var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "div",
        { staticClass: "app-header" },
        [
          _c(
            "el-form",
            {
              ref: "query",
              attrs: { model: _vm.query, size: "mini", inline: true },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "活动名称：", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入活动名称", clearable: "" },
                    model: {
                      value: _vm.query.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "name", $$v)
                      },
                      expression: "query.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "隶属公司：", prop: "merchantIds" } },
                [
                  _c("YdMerchantSelector", {
                    attrs: { multiple: "", placeholder: "请选择隶属公司" },
                    model: {
                      value: _vm.query.merchantIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "merchantIds", $$v)
                      },
                      expression: "query.merchantIds",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态：", prop: "state" } },
                [
                  _c("avue-select", {
                    attrs: {
                      placeholder: "请选择状态",
                      dic: [
                        { label: "待审核", value: 1 },
                        // {label: '已通过', value: 2},
                        { label: "已驳回", value: 3 },
                        { label: "未开始", value: 4 },
                        { label: "进行中", value: 5 },
                        { label: "已结束", value: 6 },
                        { label: "已下架", value: 7 },
                      ],
                    },
                    model: {
                      value: _vm.query.state,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "state", $$v)
                      },
                      expression: "query.state",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "开始时间：", prop: "startTime" } },
                [
                  _c("avue-date", {
                    attrs: {
                      type: "date",
                      format: "yyyy-MM-dd",
                      valueFormat: "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.query.startTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "startTime", $$v)
                      },
                      expression: "query.startTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "创建人：", prop: "nameOrPhone" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入姓名或手机号码" },
                    model: {
                      value: _vm.query.nameOrPhone,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "nameOrPhone", $$v)
                      },
                      expression: "query.nameOrPhone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "线路：", prop: "lineId" } },
                [
                  _c("YdLineSelector", {
                    model: {
                      value: _vm.query.lineId,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "lineId", $$v)
                      },
                      expression: "query.lineId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-search",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.searchChange },
                    },
                    [_vm._v("筛选")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        icon: "el-icon-delete",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.searchReset },
                    },
                    [_vm._v("清空")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "crud__container" },
        [
          _c(
            "yd-table",
            {
              ref: "crud",
              attrs: {
                columns: _vm.option.column,
                loading: _vm.loading,
                data: _vm.data,
                pagination: _vm.page,
                size: "mini",
              },
              on: { onChange: _vm.onTableChange },
              scopedSlots: _vm._u([
                {
                  key: "name",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.rowDetails(row)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(row.name) + "\n        "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "menu",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "el-dropdown",
                        {
                          attrs: {
                            size: "mini",
                            "split-button": "",
                            type: "primary",
                          },
                          on: {
                            command: function (command) {
                              return _vm.handleCommand(command, row)
                            },
                          },
                        },
                        [
                          _vm._v("\n          操作\n          "),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              row.status === "待审核"
                                ? _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "1" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "has-permi",
                                              rawName: "v-has-permi",
                                              value: [
                                                "distCountCoupon_examine",
                                              ],
                                              expression:
                                                "['distCountCoupon_examine']",
                                            },
                                          ],
                                          attrs: { type: "text", size: "mini" },
                                        },
                                        [_vm._v("通过")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              row.status === "待审核"
                                ? _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "2" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "has-permi",
                                              rawName: "v-has-permi",
                                              value: [
                                                "distCountCoupon_examine",
                                              ],
                                              expression:
                                                "['distCountCoupon_examine']",
                                            },
                                          ],
                                          attrs: { type: "text", size: "mini" },
                                        },
                                        [_vm._v("不通过")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              row.status === "待审核" ||
                              row.status === "已驳回" ||
                              row.status === "未开始"
                                ? _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "3" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "has-permi",
                                              rawName: "v-has-permi",
                                              value: ["distCountCoupon_edit"],
                                              expression:
                                                "['distCountCoupon_edit']",
                                            },
                                          ],
                                          attrs: { type: "text", size: "mini" },
                                        },
                                        [_vm._v("编辑")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              row.status === "进行中" ||
                              row.status === "已下架" ||
                              row.status === "已结束"
                                ? _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "4" } },
                                    [_vm._v("数据")]
                                  )
                                : _vm._e(),
                              row.status === "未开始" || row.status === "进行中"
                                ? _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "6" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "has-permi",
                                              rawName: "v-has-permi",
                                              value: ["distCountCoupon_delete"],
                                              expression:
                                                "['distCountCoupon_delete']",
                                            },
                                          ],
                                          attrs: { type: "text", size: "mini" },
                                        },
                                        [_vm._v("下架")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              row.status === "已驳回"
                                ? _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "5" } },
                                    [_vm._v("查看原因")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c(
                "template",
                { slot: "tools" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["distCountCoupon_add"],
                          expression: "['distCountCoupon_add']",
                        },
                      ],
                      attrs: {
                        type: "primary",
                        size: "mini",
                        icon: "el-icon-circle-plus-outline",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleAdd.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("新建活动")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _vm.addVisible
        ? _c("activities-add", {
            ref: "add",
            on: { refreshDataList: _vm.refreshChange },
          })
        : _vm._e(),
      _vm.editVisible
        ? _c("activities-edit", {
            ref: "activitiesEdit",
            on: { refreshDataList: _vm.refreshChange },
          })
        : _vm._e(),
      _vm.detailsVisible ? _c("act-details", { ref: "actDetails" }) : _vm._e(),
      _vm.viewVisible ? _c("data-view", { ref: "dataView" }) : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审核不通过",
            visible: _vm.nVisible,
            "append-to-body": true,
            width: "58%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.nVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "nInfo",
              attrs: {
                model: _vm.nInfo,
                size: "small",
                "label-width": "99px",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "不通过的原因", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入不通过原因",
                    },
                    model: {
                      value: _vm.nInfo.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.nInfo, "remark", $$v)
                      },
                      expression: "nInfo.remark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "info" },
                      on: {
                        click: function ($event) {
                          _vm.nVisible = !_vm.nVisible
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v("提交")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }